import { GROUP_TYPE, IGroupInfo, IUserInfo } from "@home-health-notify/domain";

export enum GROUP_AVATAR_SIZE {
  XXSMALL = "XXSMALL",
  XSMALL = "XSMALL",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export enum AVATAR_SIZE {
  XSMALL = 28, // Acknowledgement suggestions
  SMALL = 32, // Organization icon
  MEDIUM = 35, // Profile icon button
  LARGE = 40, // Profile menu icon, ask for ack and user directory list
  XLARGE = 150, // User profile image
}

export const getAvatarSize = (
  groupType: GROUP_TYPE,
  size: GROUP_AVATAR_SIZE,
) => {
  const groupTypeAvatarSize = {
    PATIENT_XXSMALL: 24,
    PATIENT_XSMALL: 30,
    PATIENT_SMALL: 50,
    PATIENT_MEDIUM: 40,
    PATIENT_LARGE: 60,
    NON_PATIENT_SMALL: 48,
    BROADCAST_SMALL: 33,
    PRIVATE_SMALL: 48,
    PRIVATE_LARGE: 60,
    NON_PATIENT_LARGE: 60,
    BROADCAST_LARGE: 45,
  };
  const key = `${groupType}_${size}`;
  if (Object.prototype.hasOwnProperty.call(groupTypeAvatarSize, key)) {
    return groupTypeAvatarSize[key as keyof typeof groupTypeAvatarSize];
  }
  // fallback: return a default size or undefined if not found
  return undefined;
};

export function getAvatarSrcAndAlt(info: IGroupInfo | IUserInfo) {
  return {
    src: info.image,
    alt: info.name,
  };
}
